import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { FloatingLabel, Form } from "react-bootstrap";
import { appSendLoginOtp } from "../../services/AuthServices";
import { otpLogin } from "../../store/actions/authActions";
import { PLEASE_WAIT_TXT } from "../../utils/Constant";

/**
 * BOC
 * API Security - Step 4 OTP login / signup UI
 * date 23-10-2026
 * use_of_code: Login OTP screen as per the new design. On success the customer is logged in (cart count, pixel
 * events, SID). isCheckout changes the button text to "VERIFY OTP & CHECKOUT".
 */
function OTPLogin({
  active,
  toggleAuthFormCb,
  otpResponse,
  userName,
  setVerifyOTPResponse,
  isCheckout = false,
}) {
  const [counter, setCounter] = useState(otpResponse?.resend_after || 60);
  const [otpToVerify, setOtpToVerify] = useState("");
  const [msg, setMsg] = useState("");
  const [responseData, setResponseData] = useState(otpResponse);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isResending, setIsResending] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  if (!active || !userName) return null;

  const onVerifyOTPLogin = (e) => {
    e.preventDefault();
    if (!otpToVerify.trim() || isSubmitting) {
      return;
    }
    setIsSubmitting(true);
    setMsg("");
    dispatch(otpLogin({ login_id: userName, otp: otpToVerify.trim() })).then(
      (res) => {
        if (res?.status === "success") {
          setVerifyOTPResponse(null, "");
          toggleAuthFormCb("login");
        } else {
          setIsSubmitting(false);
          setMsg(res?.message || "Something went wrong. Please try again.");
        }
      }
    );
  };

  const onResendOtpClick = () => {
    if (counter > 0 || isResending) {
      return;
    }
    setIsResending(true);
    setMsg("");
    appSendLoginOtp({ login_id: userName })
      .then((res) => {
        res = JSON.parse(res?.data);
        if (res?.status === "success") {
          setCounter(res?.resend_after || 60);
          setResponseData(res);
          setOtpToVerify("");
        } else {
          setMsg(res?.message || "Something went wrong. Please try again.");
        }
      })
      .finally(() => setIsResending(false));
  };

  return (
    <Form onSubmit={onVerifyOTPLogin} noValidate autoComplete="off">
      <p className="otp-sent-text mb-4">{responseData?.message}</p>
      <FloatingLabel controlId="login_otp" label="Enter OTP" className="mb-3">
        <Form.Control
          type="text"
          inputMode="numeric"
          maxLength={6}
          name="otp"
          autoComplete="one-time-code"
          placeholder="Enter OTP"
          value={otpToVerify}
          onChange={(e) => setOtpToVerify(e.target.value.replace(/[^0-9]/g, ""))}
        />
      </FloatingLabel>
      {msg.length > 0 ? <span className="text-danger">{msg}</span> : null}
      <button
        type="submit"
        className="btn btn-primary mt-35"
        disabled={isSubmitting || otpToVerify.length < 4}
      >
        {isSubmitting
          ? PLEASE_WAIT_TXT
          : isCheckout
          ? "VERIFY OTP & CHECKOUT"
          : "VERIFY OTP & LOGIN"}
      </button>
      <p className="mt-15 resend-otp-text">
        Didn't receive an OTP?{" "}
        <button
          className="btn-blank text-underline"
          type="button"
          disabled={counter > 0 || isResending}
          onClick={onResendOtpClick}
          style={{ color: counter > 0 ? "#949494" : "black" }}
        >
          {isResending ? PLEASE_WAIT_TXT : "Resend OTP"}
        </button>
        {counter > 0 && <span className="text-muted"> in {counter}s</span>}
      </p>
    </Form>
  );
}
/**
 * EOC
 */

export default OTPLogin;
